// AF-3.16 — OpportunityCard. Renders an opportunity's real backend
// classification (NOW/NEXT/INVESTIGATE/BLOCKED/WAITING), impact,
// confidence, and readiness. "Why now" text is either the backend's own
// why_now/reason field or omitted -- never invented.

import { ConfidenceIndicator, ReadinessBadge, StatusBadge } from "./Badges";
import { cn } from "@/lib/utils";

export function OpportunityCard({ opportunity, classification, readiness, whyNow, onClick, className }) {
  return (
    <button
      data-testid="opportunity-card"
      onClick={onClick}
      className={cn("w-full text-left rounded-[var(--radius-card)] border border-[var(--border)] bg-[var(--surface)] p-4 shadow-[var(--shadow-card)] hover:border-[var(--accent-border)] hover:shadow-[var(--shadow-hover)] transition-colors", className)}
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <p className="text-[13px] font-semibold text-[var(--text-primary)]">{opportunity?.opportunity_type?.replace(/_/g, " ") || "Opportunity"}</p>
        {classification && <StatusBadge value={classification} />}
      </div>
      <div className="flex items-center gap-3 flex-wrap text-[10px]">
        {opportunity?.priority && (
          <span className="text-[var(--text-secondary)]">Priority: <span className="text-[var(--text-primary)] font-mono">{opportunity.priority}</span></span>
        )}
        {opportunity?.impact_dimension && (
          <span className="text-[var(--text-secondary)]">Impact: <span className="text-[var(--text-primary)] font-mono">{opportunity.impact_dimension}</span></span>
        )}
        {opportunity?.confidence !== undefined && opportunity?.confidence !== null && (
          <div className="flex items-center gap-1"><span className="text-[var(--text-secondary)]">Confidence:</span><ConfidenceIndicator value={opportunity.confidence} /></div>
        )}
        {readiness && <div className="flex items-center gap-1"><span className="text-[var(--text-secondary)]">Readiness:</span><ReadinessBadge value={readiness} /></div>}
      </div>
      {whyNow && <p className="text-[11px] text-[var(--text-secondary)] mt-2 line-clamp-2">{whyNow}</p>}
    </button>
  );
}
